import { render, staticRenderFns } from "./ViewUpload.vue?vue&type=template&id=284bb44d"
import script from "./ViewUpload.vue?vue&type=script&lang=js"
export * from "./ViewUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports